import { Component, OnInit } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';

@Component({
  selector: 'app-intent-to-buy',
  templateUrl: './intent-to-buy.component.html',
  styleUrls: ['./intent-to-buy.component.scss']
})
export class IntentToBuyComponent implements OnInit,ICellRendererAngularComp {
  params;
 inputValue:string;
 color:string = "#707070";
  constructor() { }

  agInit(params: ICellRendererParams<any, any>): void {
    this.params = params;
    this.updateValue(params)
  }
  updateValue(params) {
    switch (params?.column?.colId) {
      case 'intentToBuyId':
        this.inputValue = params?.data?.intentToBuyName;
        this.color = params?.data?.intendToBuyColorCode
        break
      case 'leadScoreId':
        this.inputValue = params?.data?.leadScoreName
        break
      case 'offerScore':
        this.inputValue = this.params.value??'NA'
        break
      default:
        this.inputValue = this.params.value
        break
    }
  }
  refresh(params: ICellRendererParams<any, any>): boolean {
    this.params = params;
    return true;
  }

  ngOnInit(): void {
  }

}
